import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import ArrowLeftIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/ArrowLeftIconPath";

type BackButtonProps = {
  onClick: () => void;
  children: string;
  className?: string;
};

export const BackButton = ({
  onClick,
  children,
  className,
}: BackButtonProps) => (
  <FixaButton
    className={className}
    iconPosition="leading"
    ssrIcon={ArrowLeftIconPath}
    text={children}
    size="small"
    type="tertiary"
    onClick={onClick}
  />
);
